import { fromJS, List } from 'immutable';
import { MODULE_NAME } from './constants';

export const SET_USER_STATUS = `modules/${MODULE_NAME}/SET_USER_STATUS`;
export const SET_USER_NAME = `modules/${MODULE_NAME}/SET_USER_NAME`;
export const MERGE_VALUES = `modules/${MODULE_NAME}/MERGE_VALUES`;
export const SET_USER_PROFILE = `modules/${MODULE_NAME}/SET_USER_PROFILE`;
export const SET_WISHLISTED_COUNTRIES = `modules/${MODULE_NAME}/SET_WISHLISTED_COUNTRIES`;
export const SET_WISHLIST_ERROR = `modules/${MODULE_NAME}/SET_WISHLIST_ERROR`;
export const SET_PROFILE_STATUS_LOADING = `modules/${MODULE_NAME}/SET_PROFILE_STATUS_LOADING`;
export const SET_PROFILE_STATUS_API_ERROR = `modules/${MODULE_NAME}/SET_PROFILE_STATUS_API_ERROR`;
export const SET_PROFILE_INFO_API_ERROR = `modules/${MODULE_NAME}/SET_PROFILE_INFO_API_ERROR`;
export const SET_COUNTRY_LIST_API_ERROR = `modules/${MODULE_NAME}/SET_COUNTRY_LIST_API_ERROR`;
export const SET_STAMPS_LIST_API_ERROR = `modules/${MODULE_NAME}/SET_STAMPS_LIST_API_ERROR`;
export const SET_IS_FULLSCREEN_ERROR = `modules/${MODULE_NAME}/SET_IS_FULLSCREEN_ERROR`;
export const SET_IS_MOBILE = `modules/${MODULE_NAME}/SET_IS_MOBILE`;
export const SET_TRIP_HIGHLIGHTS_UPDATE = `modules/${MODULE_NAME}/SET_TRIP_HIGHLIGHTS_UPDATE`;
export const SET_TRIP_HIGHLIGHTS_UPDATED_ID = `modules/${MODULE_NAME}/SET_TRIP_HIGHLIGHTS_UPDATED_ID`;
export const SET_VIEWED_STAMP = `modules/${MODULE_NAME}/SET_VIEWED_STAMP`;
export const SET_STAMP_DETAILS = `modules/${MODULE_NAME}/SET_STAMP_DETAILS`;
export const REMOVE_STAMP = `modules/${MODULE_NAME}/REMOVE_STAMP`;
export const SET_SHOW_SCAN_BANNER = `modules/${MODULE_NAME}/SET_SHOW_SCAN_BANNER`;
export const SET_SHOW_PUSH_NOTIFICATION_BANNER = `modules/${MODULE_NAME}/SET_SHOW_PUSH_NOTIFICATION_BANNER`;
export const SET_PROFILE_REFRESH = `modules/${MODULE_NAME}/SET_PROFILE_REFRESH`;
export const SET_COUNTRY_LIST_LOADING = `modules/${MODULE_NAME}/SET_COUNTRY_LIST_LOADING`;
export const SET_PROFILE_INFO_LOADING = `modules/${MODULE_NAME}/SET_PROFILE_INFO_LOADING`;
export const REMOVE_COUNTRY_CODE_FOR_HIDDEN_STAMP = `modules/${MODULE_NAME}/REMOVE_COUNTRY_CODE_FOR_HIDDEN_STAMP`;
export const SET_STAMPS_DATA_LOADING = `modules/${MODULE_NAME}/SET_STAMPS_DATA_LOADING`;
export const PREFETCHED_MODULE_URLS = `modules/${MODULE_NAME}/PREFETCHED_MODULE_URLS`;
export const SET_WISHLIST_SAVING = `modules/${MODULE_NAME}/SET_WISHLIST_SAVING`;
export const TOGGLE_STACKED_STAMPS = `modules/${MODULE_NAME}/TOGGLE_STACKED_STAMPS`;

export const initialState = fromJS({
  userName: null,
  userStatus: null,
  userProfile: null,
  visitedCountryCodes: [],
  wishlistedCountryCodes: [],
  amexAcceptedCountries: {
    codes: [],
    data: {},
  },
  isProfileStatusApiError: false,
  isProfileInfoApiError: false,
  isCountryListApiError: false,
  isStampsListApiError: false,
  isFullScreenError: false,
  showRemoveStampBanner: false,
  isUserUnenrolled: false,
  removedStampName: null,
  isMobile: true,
  stamps: {
    ids: [],
    data: {},
    stampFeedIds: [],
    stackedData: {},
  },
  hiddenStampCountryCodes: [],
  eligibleCardsPresentIndicator: true,
  showEnablePushNotificationBanner: false,
  isStampsDataLoading: false,
  isExperimentReady: false,
  isTilesDispersed: false,
  userID: null,
  fetchedUrlModuleNames: [],
  isWishlistSaving: false,
});

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case MERGE_VALUES:
      return state.merge(state, payload);
    case SET_USER_STATUS:
      return state.set('userStatus', payload);
    case SET_USER_PROFILE:
      return state.withMutations((mutableState) => {
        mutableState.set('userProfile', payload);
        mutableState.set('isProfileInfoLoading', false);
      });
    case SET_USER_NAME:
      return state.set('userName', payload);
    case SET_PROFILE_STATUS_LOADING:
      return state.set('isProfileStatusLoading', payload);
    case SET_STAMPS_DATA_LOADING:
      return state.set('isStampsDataLoading', payload);
    case SET_PROFILE_STATUS_API_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('isProfileStatusApiError', payload);
        mutableState.set('isProfileStatusLoading', false);
      });
    case SET_PROFILE_INFO_API_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('isProfileInfoApiError', payload);
        mutableState.set('isProfileInfoLoading', false);
      });
    case SET_PROFILE_INFO_LOADING:
      return state.set('isProfileInfoLoading', payload);
    case SET_COUNTRY_LIST_API_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('isCountryListApiError', payload);
        mutableState.set('isCountryListLoading', false);
      });
    case SET_IS_FULLSCREEN_ERROR:
      return state.set('isFullScreenError', payload);
    case SET_COUNTRY_LIST_LOADING:
      return state.set('isCountryListLoading', payload);
    case SET_WISHLISTED_COUNTRIES:
      return state.withMutations((mutableState) => {
        mutableState.set('wishlistedCountryCodes', List(payload.wishlistCountryCodes));
        payload.wishlistCountryCodes.forEach((code) => {
          mutableState.setIn(['amexAcceptedCountries', 'data', code, 'is_wishlisted'], true);
        });
        payload.previouslyWishlistedCountryCodes.forEach((code) => {
          mutableState.setIn(['amexAcceptedCountries', 'data', code, 'is_wishlisted'], false);
        });
        mutableState.set('wishlistError', null);
        mutableState.set('isWishlistSaving', false);
      });
    case SET_WISHLIST_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('wishlistError', payload);
        mutableState.set('isWishlistSaving', false);
      });
    case SET_WISHLIST_SAVING:
      return state.withMutations((mutableState) => {
        mutableState.set('isWishlistSaving', payload);
        const wishlistError = mutableState.get('wishlistError')?.set('isError', false) || fromJS({ isError: false });
        mutableState.set('wishlistError', wishlistError);
      });
    case SET_STAMPS_LIST_API_ERROR:
      return state.set('isStampsListApiError', payload);
    case SET_IS_MOBILE:
      return state.set('isMobile', payload);
    case SET_TRIP_HIGHLIGHTS_UPDATED_ID:
      return state.set('tripHighlightsUpdatedId', payload);
    case SET_TRIP_HIGHLIGHTS_UPDATE: {
      // checking for tripHighlights as there can be empty object
      return state.withMutations((mutableState) => {
        const { id, ...updates } = payload;
        mutableState.updateIn(['stamps', 'data', id, 'trip_highlights'], (tripHighlights) => (tripHighlights ? tripHighlights.merge(updates) : fromJS(updates)));
        mutableState.set('tripHighlightsUpdatedId', id);
      });
    }
    case SET_STAMP_DETAILS: {
      const { id, updates } = payload;
      return state.withMutations((mutableState) => {
        mutableState.mergeIn(['stamps', 'data', id], updates);
        mutableState.set('isStampDetailsCalled', true);

        const stamp = mutableState.getIn(['stamps', 'data', id]);
        const [year] = stamp.get('earned_date').split('-');
        const stackedKey = `stacked-${stamp.get('country_code')}-${year}`;
        const stackedData = mutableState.getIn(['stamps', 'stackedData', stackedKey]);
        if (stackedData) {
          const stackedIds = mutableState.getIn(['stamps', 'stackedData', stackedKey, 'ids']);
          const newIndicator = stackedIds.some((stampId) => mutableState.getIn(['stamps', 'data', stampId, 'new_stamp_indicator']));
          mutableState.setIn(['stamps', 'stackedData', stackedKey, 'new_stamp_indicator'], newIndicator);
        }
      });
    }
    case REMOVE_STAMP:
      return state.withMutations((mutableState) => {
        mutableState.set('showRemoveStampBanner', true);
        mutableState.set('removedStampName', payload.stampName);
        const deletedStamp = mutableState.getIn(['stamps', 'data', payload.stampId]);
        const countryCode = deletedStamp.get('country_code');
        const hiddenStampCountryCodes = mutableState.get('hiddenStampCountryCodes').toJS();
        if (!hiddenStampCountryCodes.includes(countryCode)) {
          hiddenStampCountryCodes.push(countryCode);
          mutableState.set('hiddenStampCountryCodes', fromJS(hiddenStampCountryCodes));
        }
        mutableState.deleteIn(['stamps', 'ids', mutableState.getIn(['stamps', 'ids']).indexOf(payload.stampId)]);
        mutableState.deleteIn(['stamps', 'data', payload.stampId]);

        const tripHighlightsUpdatedId = mutableState.get('tripHighlightsUpdatedId');
        if (tripHighlightsUpdatedId && tripHighlightsUpdatedId === payload.stampId) {
          mutableState.set('tripHighlightsUpdatedId', null);
        }

        const [year] = deletedStamp.get('earned_date').split('-');
        const stackedKey = `stacked-${countryCode}-${year}`;
        const stackedData = mutableState.getIn(['stamps', 'stackedData', stackedKey]);
        if (!stackedData) {
          mutableState.deleteIn(['stamps', 'stampFeedIds', mutableState.getIn(['stamps', 'stampFeedIds']).indexOf(payload.stampId)]);
        } else {
          let shouldSortStack = stackedData.get('ids').indexOf(payload.stampId) === 0;
          const updatedStackedIds = stackedData.get('ids').filter((id) => id !== payload.stampId);
          if (updatedStackedIds.size === 1) {
            const position = mutableState.getIn(['stamps', 'stampFeedIds']).indexOf(stackedKey);
            mutableState.setIn(['stamps', 'stampFeedIds', position], updatedStackedIds.get(0));
            // remove the stacked stamp entry if no stamps are left
            mutableState.deleteIn(['stamps', 'stackedData', stackedKey]);
            shouldSortStack = true;
          } else {
            mutableState.setIn(['stamps', 'stackedData', stackedKey, 'ids'], updatedStackedIds);
          }
          if (shouldSortStack) {
            const getStackedEarnedDate = (stackedId) => {
              const firstStampId = mutableState.getIn(['stamps', 'stackedData', stackedId, 'ids', 0]);
              return mutableState.getIn(['stamps', 'data', firstStampId, 'earned_date']);
            };
            const stampUsId = mutableState.getIn(['stamps', 'stampFeedIds']).last();
            const stampFeedIdWithoutUS = mutableState.getIn(['stamps', 'stampFeedIds']).pop();
            const sortedStackedIds = stampFeedIdWithoutUS.sort((a, b) => {
              const aEarnedDate = a.includes('stacked')
                ? getStackedEarnedDate(a)
                : mutableState.getIn(['stamps', 'data', a, 'earned_date']);
              const bEarnedDate = b.includes('stacked')
                ? getStackedEarnedDate(b)
                : mutableState.getIn(['stamps', 'data', b, 'earned_date']);
              return new Date(bEarnedDate) - new Date(aEarnedDate);
            });
            mutableState.setIn(['stamps', 'stampFeedIds'], sortedStackedIds.push(stampUsId)); // US stamp is always last
          }
        }
      });
    case REMOVE_COUNTRY_CODE_FOR_HIDDEN_STAMP:
      return state.deleteIn(['hiddenStampCountryCodes', state.get('hiddenStampCountryCodes').indexOf(payload)]);
    case SET_SHOW_SCAN_BANNER:
      return state.set('showScanBanner', payload);
    case SET_SHOW_PUSH_NOTIFICATION_BANNER:
      return state.set('showEnablePushNotificationBanner', payload);
    case SET_PROFILE_REFRESH:
      return state.set('canProfileRefresh', payload);
    case PREFETCHED_MODULE_URLS:
      return state.update('fetchedUrlModuleNames', (list) => (list.includes(payload) ? list : list.push(payload)));
    case TOGGLE_STACKED_STAMPS: {
      const isExpanded = state.getIn(['stamps', 'stackedData', payload, 'isExpanded']);
      return state.setIn(['stamps', 'stackedData', payload, 'isExpanded'], !isExpanded);
    }
    default: return state;
  }
};

export default reducer;
